import React from "react"
import tw from "twin.macro"
import ProfilePhoto, { Width } from "../profilePhoto"
import { QuestionSearchResult, SourceCommentSearchResult } from "../../graphql/generated/graphql"
import { Routes } from "../../routes"
import { useTranslation } from "next-i18next"
import Image from "next/image"

interface DropdownProps {
  videos: SourceCommentSearchResult[]
  questions: QuestionSearchResult[]
  focus: number
  setFocus: React.Dispatch<React.SetStateAction<number>>
  handleSelect: (id: string, value?: string, route?: string) => void
  input: string
}
export const Dropdown = ({ videos, questions, focus, setFocus, handleSelect, input }: DropdownProps) => {
  const { t } = useTranslation("profile")
  const showDropDown = input && (videos.length > 0 || questions.length > 0)

  return (
    <>
      {showDropDown && (
        <div tw="w-full absolute bg-white border-base-6 border-2 rounded-xl top-[50px] max-h-[260px] z-20 overflow-scroll">
          {videos.map(({ videoId, thumbnail, count, youTubeVideoTitle, instagramMediaCaption, highlight }, index) => (
            <div
              tw="flex items-center h-[52px] border-b border-b-[#E3E3E3] px-3.5 hover:(text-purple cursor-pointer)"
              css={focus === index ? tw`text-white bg-purple` : tw``}
              key={index}
              onClick={async () => await handleSelect(videoId, `${youTubeVideoTitle ?? instagramMediaCaption}`)}
              onMouseEnter={() => setFocus(-1)}
            >
              <Image
                loader={() => `${thumbnail}`}
                src={`${thumbnail}`}
                width={60}
                height={34}
                tw="rounded !border-solid border-2 border-[#1C1C1C]"
              />
              <div tw="flex flex-col ml-4 overflow-hidden">
                <div
                  tw="text-xs whitespace-nowrap overflow-ellipsis overflow-hidden"
                  css={"em {font-weight: bold}"}
                  dangerouslySetInnerHTML={{
                    __html: `${highlight.youTubeVideoTitle?.value ?? highlight.instagramMediaCaption?.value}`,
                  }}
                ></div>
                <span tw="text-xs">{t("search.questions", { count })}</span>
              </div>
            </div>
          ))}
          {questions.map(({ Fan, id, body, highlight }, index) => (
            <div
              tw="flex items-center h-[52px] border-b border-b-[#E3E3E3] px-3.5 hover:(text-purple cursor-pointer)"
              css={focus === index + videos.length ? tw`text-white bg-purple` : tw``}
              key={index}
              onClick={() => handleSelect(id, input, Routes.ShowQuestion)}
              onMouseEnter={() => setFocus(-1)}
            >
              <ProfilePhoto width={Width.W24} username={Fan.name ?? ""} profilePictureUrl={Fan.profilePictureUrl} />
              <div tw="ml-4 overflow-hidden">
                <span
                  tw="text-xs"
                  css={"em {font-weight: bold}"}
                  dangerouslySetInnerHTML={{
                    __html: `${highlight.fanName?.value ?? ""} ${t("search.asked")}`,
                  }}
                />
                <div tw="text-xs whitespace-nowrap overflow-ellipsis overflow-hidden">{body}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
